import React from 'react';
import config from '../config';

const WhyCFO = () => {
  return (
    <section className="why-cfo-section" id="why-cfo">
      <div className="container">
        <div className="why-cfo-layout">

          {/* Right Image */}
          <div className="why-cfo-image">
            <div className="image-container">
              <img 
                src={`${config.imageBaseURL}${config.paths.images}why_cfo.webp`}
                alt="Why CFO Bridge - Professional Financial Services" 
                className="professional-image"
              />
            </div>
          </div>
          {/* Left Content */}
          <div className="why-cfo-content">
            {/*<div className="author-info">
              <h3 className="author-name">CFO BRIDGE</h3>
              <p className="author-role">financial experts</p>
            </div> */}
            
            <div className="section-content">
              <h2 className="main-heading">Why Choose CFO Bridge USA?</h2>
              
              <div className="description" style={{'textAlign':'justify'}}>
                <p>At CFO Bridge USA we embed seasoned finance leaders who are outsourced cfos into your business as virtual cfo's, interim cfo, or in a hybrid model to fastrack decision-making, increase cash flow and accelerate scaling. Our plug-and-play model with CFO consultants lets you have flexibility and elite financial expertise up or down as your needs evolve.</p>
                
                <ul className="benefits-list" style={{ marginTop: '20px', listStyle: 'none', padding: 0 }}>
                  <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
                    <span style={{ color: '#1E4FA8', marginRight: '10px', fontSize: '20px' }}>•</span>
                    <span>Accessible expert talent: 40+ career CFOs with multi-industry track records ready to engage on demand.</span>
                  </li>
                  <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
                    <span style={{ color: '#1E4FA8', marginRight: '10px', fontSize: '20px' }}>•</span>
                    <span>End-to-end delivery: From roadmap to execution, we own outcomes so your leadership can stay focused on the core business.</span>
                  </li>
                  <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
                    <span style={{ color: '#1E4FA8', marginRight: '10px', fontSize: '20px' }}>•</span>
                    <span>Affordable value-addition: Our fractional CFO services Save up to 70% versus hiring a full-time finance team while unlocking enterprise-grade insight.</span>
                  </li>
                  <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
                    <span style={{ color: '#1E4FA8', marginRight: '10px', fontSize: '20px' }}>•</span>
                    <span>U.S. presence, global horsepower: Based in United States we combine local market knowledge with deep international expertise.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </section>
  );
};

export default WhyCFO;
